var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSelected = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25.5 25.5",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_success")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bswap",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-Box_\\u7EA2\\u5305\\u5386\\u53F2",
    transform: "translate(-525.250000, -239.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EFF\\u8272",
    transform: "translate(526.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62-copy",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    fill: "#6D4EC9",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35944527,12 C6.83870563,11.5409709 7.61574021,11.5409709 8.09500057,12 L9.83055587,13.6622913 L15.9049994,7.8442718 C16.3842598,7.38524273 17.1612944,7.38524273 17.6405547,7.8442718 C18.1198151,8.30330086 18.1198151,9.04753402 17.6405547,9.50656308 L10.6983335,16.1557282 C10.2190732,16.6147573 9.44203859,16.6147573 8.96277822,16.1557282 L6.35944527,13.6622913 C5.88018491,13.2032622 5.88018491,12.4590291 6.35944527,12 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF"
  }))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSelected, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_selected.d057b548.svg";
export { ForwardRef as ReactComponent };